module.exports = __webpack_public_path__ + "static/img/bg2@2x.b942a468.png";